import { getAuth, signInWithCustomToken } from 'firebase/auth';

import BackofficeApi from "../api/BackofficeApi";
import AppDispatcher from "../dispatcher/AppDispatcher";
import { AuthenticationActionsType } from '../constant/ActionConstant';
import Establishment from "../model/Establishment";
import PopinaApi from "../api/PopinaApi";
import UbereatsActionCreator from './UbereatsActionCreator';
import Environment from '../../utils/Environement';
import ImageActionCreators from './ImageActionCreators';
import { getDataFromLocalStorage, removeDataFromLocalStorage, saveDataToLocalStorage } from '../../utils/localStorage';

class AuthenticationActionCreator {

    private backApi: BackofficeApi
    private popinaApi: PopinaApi

    constructor() {
        this.backApi = new BackofficeApi(Environment.isDev, Environment.isPopina);
        this.popinaApi = new PopinaApi(Environment.isDev, Environment.isPopina);
    }

    async loginWithEmailAndPassword(email: string, password: string): Promise<void> {
        try {
            const res = await this.backApi.connectWithEmailAndPassword(email, password);
            const uid = res.data.uid as string;
            const res2 = await this.backApi.fetchAccountWithUid(uid);
            const establishments = res2.data.establishments.map((aEst: any) => new Establishment(aEst));
            AppDispatcher.dispatch({
                'type': AuthenticationActionsType.LOGGED,
                'data': establishments
            });
            saveDataToLocalStorage('boAccountId',uid);
        }
        catch (e) {
            throw e;
        }
    }

    async selectEstablishment(establishment: Establishment): Promise<void> {
        try {
            const auth = getAuth()
            const res = await this.popinaApi.firAuthToken(establishment.id.toString());
            const token = res.data['token'] as string;
            AppDispatcher.dispatch({
                'type': AuthenticationActionsType.SELECT_ESTABLISHMENT,
                'data': establishment.setFirToken(token)
            });
            const authResult = await signInWithCustomToken(auth,token);
            if (authResult.user) {
                AppDispatcher.dispatch({
                    'type': AuthenticationActionsType.LOGGED_FIR,
                    'data': authResult.user
                });
                ImageActionCreators.fetchCurrentImageBucket();
                saveDataToLocalStorage('selectedEstablishmentId', establishment.id);
            }
            else {
                throw new Error("Fir auth Error no user finded");
            }
        }
        catch (e) {
            throw e;
        }
    }

    async loginWithRestaurantToken(token: string, restaurantID: string, name: string, locationId: string): Promise<void> {
        const establishment = new Establishment({ 'token': token, 'name': name, 'id': parseInt(restaurantID) });
        return this.selectEstablishment(establishment).then(() => {
            return UbereatsActionCreator.connectUberEatServiceUser(locationId).then(() => {
                return;
            });
        });
    }


  async checkIfEstablishmentAlreadyLogged() {
    const selectedEstablishmentId = getDataFromLocalStorage(
      "selectedEstablishmentId"
    );
    const uid = getDataFromLocalStorage("boAccountId");
    const res = await this.backApi.fetchAccountWithUid(uid);
    const establishments = res.data.establishments.map(
      (aEst: any) => new Establishment(aEst)
    );
    AppDispatcher.dispatch({
      type: AuthenticationActionsType.LOGGED,
      data: establishments,
    });

    const establishment = establishments.find(
      (establ: Establishment) => establ.id === selectedEstablishmentId
    );

    if (establishment) {
      await this.selectEstablishment(establishment);
    }
  }

   logoutEstablishment = async () => {
        removeDataFromLocalStorage('boAccountId');
        removeDataFromLocalStorage('selectedEstablishmentId');
        AppDispatcher.dispatch({
            'type': AuthenticationActionsType.LOGGED_FIR,
            'data': undefined
        });
        AppDispatcher.dispatch({
            'type': AuthenticationActionsType.SELECT_ESTABLISHMENT,
            'data': undefined
        });
    }


}

const authenticationActionCreator = new AuthenticationActionCreator();
export default authenticationActionCreator;